<template>
    <div class="border-2 border-tp-yellow rounded-xl p-4">
        <p class="text-sm">{{ statType }}</p>
        <p class="text-2xl">{{ statValue }}</p>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    statType: String,
    statValue: Number,
});
</script>